<mat-label>{{ label }}</mat-label>
<form [formGroup]="timePicker" class="time-picker">
  <mat-form-field appearance="outline">
    <mat-label>Hours</mat-label>
    <mat-select required formControlName="hours">
      <mat-option
        *ngFor="let m of hours; let i = index"
        [value]="i < 10 ? '0' + i : i"
        >{{ i < 10 ? 0 : "" }}{{ i }}</mat-option
      >
    </mat-select>
    <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
  </mat-form-field>
  :
  <mat-form-field appearance="outline">
    <mat-label>Minutes</mat-label>
    <mat-select required formControlName="minutes">
      <mat-option
        *ngFor="let m of minutes; let i = index"
        [value]="i < 10 ? '0' + i : i"
        >{{ i < 10 ? 0 : "" }}{{ i }}</mat-option
      >
    </mat-select>
    <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
  </mat-form-field>
  :
  <mat-form-field appearance="outline">
    <mat-label>Format</mat-label>
    <mat-select required formControlName="format">
      <mat-option *ngFor="let m of format; let i = index" [value]="m">{{
        m
      }}</mat-option>
    </mat-select>
    <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
  </mat-form-field>
</form>
